
const firebaseConfig = {
  apiKey: "AIzaSyCGWfaEfhCQP6sxmlvv5z7XNT3AKRPanyM",
  authDomain: "tourism-website-386be.firebaseapp.com",
  projectId: "tourism-website-386be",
  storageBucket: "tourism-website-386be.appspot.com",
  messagingSenderId: "1077309794306",
  appId: "1:1077309794306:web:641789bc5d76731b3b1f1b"
};

export default firebaseConfig;